// Public site sections that live on their own URL (plus the 7 locale prefixes).
import { getGuide } from './i18n/guide';

export const SUPPORTED_LANGS = ['en', 'me', 'sq', 'de', 'ru', 'pl', 'hu'];

export const SECTIONS = [
  { slug: 'rooms', id: 'rooms', navKey: 'nav.rooms', titleKey: 'rooms.title', descKey: 'rooms.description' },
  { slug: 'amenities', id: 'amenities', navKey: 'nav.amenities', titleKey: 'amenities.title', descKey: 'amenities.subtitle' },
  { slug: 'gallery', id: 'gallery', navKey: 'nav.gallery', titleKey: 'gallery.title', descKey: 'gallery.subtitle' },
  { slug: 'virtual-tour', id: '360-tour', navKey: 'nav.virtualTour', titleKey: 'nav.virtualTour', descKey: 'gallery.subtitle' },
  { slug: 'location', id: 'location', navKey: 'nav.location', titleKey: 'location.title', descKey: 'location.subtitle' },
  { slug: 'reviews', id: 'reviews', navKey: 'footer.reviews', titleKey: 'reviews.heading', descKey: 'reviews.lead' },
  { slug: 'faq', id: 'faq', navKey: 'faq.subtitle', titleKey: 'faq.title', descKey: 'faq.title' },
  { slug: 'contact', id: 'contact', navKey: 'nav.contact', titleKey: 'contact.title', descKey: 'contact.subtitle' },
  { slug: 'ulcinj-guide', id: 'ulcinj-guide', navKey: 'guide.nav', titleKey: 'guide.title', descKey: 'guide.subtitle',
    seo: (lang) => ({ title: getGuide(lang).metaTitle, description: getGuide(lang).metaDescription }) },
];

// Locale prefix for the current path ('' for English / no prefix).
export const langPrefixFromPath = (pathname) => {
  const seg = pathname.split('/').filter(Boolean)[0];
  return seg && SUPPORTED_LANGS.includes(seg) && seg !== 'en' ? `/${seg}` : '';
};

export const sectionPath = (slug, pathname) => `${langPrefixFromPath(pathname)}/${slug}`;
export const homePath = (pathname) => langPrefixFromPath(pathname) || '/';

// Same page in another language: strip the current prefix, add the new one ('' for English).
export const switchLangPath = (pathname, code) => {
  const segs = pathname.split('/').filter(Boolean);
  if (segs.length && SUPPORTED_LANGS.includes(segs[0])) segs.shift();
  const rest = segs.length ? `/${segs.join('/')}` : '';
  return code === 'en' ? (rest || '/') : `/${code}${rest || '/'}`;
};
